export default "__VITE_ASSET__f73877af__"